var _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#00c3d6",
    height: 120.5,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0.0 -0.5 118.3 120.5",
    width: 118.3,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 0",
    fill: "inherit",
    stroke: "#449fdb"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "change1_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.836 80c1.104 0 2-0.9 2-2v-44c0-1.104-0.896-2-2-2h-16c-1.104 0-2 0.896-2 2v44c0 1.1 0.896 2 2 2h16z",
    fill: "inherit"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "change1_7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.836 80c1.1 0 2-0.9 2-2v-44c0-1.104-0.9-2-2-2h-16c-1.1 0-2 0.896-2 2v44c0 1.1 0.9 2 2 2h16z",
    fill: "inherit"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "change1_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.732 24h112.456c0.028-0.004 0.056-0.004 0.080 0 1.104 0 2-0.896 2-2 0-0.988-0.716-1.808-1.656-1.972l-57.268-19.916c-0.436-0.152-0.912-0.148-1.34 0.012l-54.956 20c-0.912 0.332-1.456 1.268-1.284 2.228 0.168 0.952 0.996 1.648 1.968 1.648z",
    fill: "inherit"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.836 67.572c-1.476 0-4.908-0.44-4.908-4.516 0-1.104-0.896-2-2-2s-2 0.896-2 2c0 4.46 2.752 7.64 7.024 8.36-0.060 0.188-0.12 0.38-0.12 0.584v4c0 1.1 0.896 2 2 2s2-0.9 2-2v-4c0-0.212-0.060-0.4-0.12-0.584 4.272-0.72 7.020-3.896 7.020-8.36 0-5.152-2.876-6.752-6.848-8.964l-2.18-1.224c-3.944-2.2-4.78-2.76-4.78-5.456 0-4.244 3.756-4.572 4.908-4.572 1.444 0 4.808 0.444 4.808 4.572 0 1.104 0.9 2 2 2 1.104 0 2-0.896 2-2 0-4.444-2.664-7.616-6.808-8.384v-3.028c0-1.104-0.896-2-2-2s-2 0.896-2 2v3.024c-4.2 0.756-6.908 3.936-6.908 8.388 0 5.136 2.864 6.74 6.832 8.948l2.184 1.228c3.96 2.204 4.796 2.76 4.796 5.468 0.008 4.068-3.424 4.516-4.9 4.516z",
    fill: "inherit"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "change1_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.836 86v10h100v-10c0-1.1-0.9-2-2-2h-96c-1.104 0-2 0.9-2 2z",
    fill: "inherit"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "change1_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.836 100h-112c-1.104 0-2 0.9-2 2v16c0 1.1 0.896 2 2 2h112c1.1 0 2-0.9 2-2v-16c0-1.1-0.9-2-2-2z",
    fill: "inherit"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanking);
export default __webpack_public_path__ + "static/media/banking.1ec701614f2e5e2aca3b83e66738a969.svg";
export { ForwardRef as ReactComponent };